import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectivityService {
  public authLogoutSubject: Subject<any> = new Subject<any>();
  constructor() { }
}
